// @owners { team: patients-team }
export const PlayButtonXml = `
<svg width="290" height="290" viewBox="0 0 290 290" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_d_13696_398386)">
    <circle cx="145" cy="141" r="121" fill="#192026" fill-opacity="0.75"/>
  </g>
  <path d="M211 137.536C213.667 139.076 213.667 142.925 211 144.464L115 199.89C112.333 201.429 109 199.505 109 196.426L109 85.5744C109 82.4952 112.333 80.5707 115 82.1103L211 137.536Z" fill="white"/>
  <defs>
    <filter id="filter0_d_13696_398386" x="0" y="0" width="290" height="290" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="4"/>
      <feGaussianBlur stdDeviation="12"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0 0.509804 0 0 0 0.24 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13696_398386"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13696_398386" result="shape"/>
    </filter>
  </defs>
</svg>
`;
